export default __webpack_public_path__ + "static/media/Arm-straps of the Silent Slayer.057ba539.jpg";